import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { useLocation } from 'react-router'
import { TextField } from 'shared/ui/TextField'
import { Alert, Avatar, Box, SpinnerLoader, Typography } from 'shared/ui'
import { CHAR_MAX_LENGTH } from 'shared/constants/limits'
import { MessageField } from 'widgets/MessageField'
import { PreviewSavedReplyContent } from 'pages/settings/pages/savedReplies/ui/SavedRepliesPageContent/EditSaveReplyContent/PreviewSavedReplyContent/PreviewSavedReplyContent'
import { useSavedRepliesContext } from 'pages/settings/pages/savedReplies/context/savedRepliesContext'
import { SavedRepliesPath } from 'pages/settings/pages/savedReplies/route/savedRepliesPath'
import { SavedReplyActions } from './SavedReplyActions/SavedReplyActions'

import styles from './styles.module.scss'

export const EditSaveReplyContent = observer(() => {
  const { newSavedReplyStore, canManageSavedReplies, hasSavedReplies, loading } =
    useSavedRepliesContext()
  const { messageFieldStore, title, setTitle, createdByUser, showCreatedBy } = newSavedReplyStore
  const isLengthAlertShow = title.length > CHAR_MAX_LENGTH

  const location = useLocation()

  useEffect(() => {
    if (location.pathname === SavedRepliesPath.create) {
      newSavedReplyStore.handleNewSavedReply()
    }
  }, [])

  if (!hasSavedReplies && loading) {
    return (
      <Box display='flex' justifyContent='center' alignItems='center' height='100%' pb={'64px'}>
        <SpinnerLoader ariaLabel={'EditSaveReplyContent'} size={24} />
      </Box>
    )
  }

  return (
    <div className={styles.wrap}>
      <div className={styles.alertContainer} ref={messageFieldStore.setAlertElement} />
      {isLengthAlertShow && (
        <Alert
          item={{
            type: 'alert',
            desc: `Title should not be longer than ${CHAR_MAX_LENGTH} characters`,
          }}
          marginBottom={28}
        />
      )}
      <TextField
        className={styles.textField}
        size='medium'
        variant='integrated'
        InputProps={{
          placeholder: 'Title',
        }}
        value={title}
        onChange={setTitle}
        disabled={!canManageSavedReplies}
      />
      {showCreatedBy && (
        <Box display='flex' gap='6px' alignItems='center' padding='3px 0 20px'>
          <Typography
            variant='body-rg-regular'
            color='var(--content-primary-secondary)'
            ariaLabel='createdBy'
          >
            {`Created by${createdByUser ? '' : ' deleted user'}`}
          </Typography>
          {createdByUser && (
            <>
              <Avatar info={createdByUser.avatarInfo} size={16} />{' '}
              <Typography
                variant='body-rg-regular'
                color='var(--content-primary-secondary)'
                ariaLabel='createdBy'
              >
                {createdByUser.name}
              </Typography>
            </>
          )}
        </Box>
      )}
      {canManageSavedReplies ? (
        <MessageField messageFieldStore={messageFieldStore} />
      ) : (
        <PreviewSavedReplyContent />
      )}
      <SavedReplyActions />
    </div>
  )
})
